// extracted by mini-css-extract-plugin
export var aside = "aside-module--aside--b4f30";
export var expandable = "aside-module--expandable--77243";
export var expander = "aside-module--expander--521fe";
export var hint = "aside-module--hint--7f0dd";
export var important = "aside-module--important--ebdc1";
export var note = "aside-module--note--1d5a0";
export var warning = "aside-module--warning--59def";